export const API_URL = `${window.location.protocol}//${process.env.SERVER_DOMAIN}/api`;
